import { FilterX, PackageOpen } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface OrderTrackingEmptyStateProps {
  variant: 'no_orders' | 'no_filter_results';
  onClearFilters?: () => void;
}

export function OrderTrackingEmptyState({ variant, onClearFilters }: OrderTrackingEmptyStateProps) {
  const { t } = useTranslation();
  const isFiltered = variant === 'no_filter_results';

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center border border-dashed border-gray-200 rounded-lg bg-gray-50">
      {isFiltered ? (
        <FilterX className="h-10 w-10 text-gray-400 mb-3" />
      ) : (
        <PackageOpen className="h-10 w-10 text-gray-400 mb-3" />
      )}
      <p className="text-sm font-medium text-gray-900">
        {t(isFiltered ? 'orderTracking.empty.noFilterResultsTitle' : 'orderTracking.empty.noOrdersTitle')}
      </p>
      <p className="text-sm text-gray-500 mt-1 max-w-md">
        {t(isFiltered ? 'orderTracking.empty.noFilterResultsDescription' : 'orderTracking.empty.noOrdersDescription')}
      </p>
      {isFiltered && onClearFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="mt-4 px-4 py-2 text-sm font-medium text-white bg-[#1681ba] rounded-md hover:bg-[#1370a3]"
        >
          {t('orderTracking.empty.clearFilters')}
        </button>
      )}
    </div>
  );
}
